/**
 *
 * @module userProfile
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyObject,
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class UserProfile
 * @since 3.5.0
 *
 */
export default class UserProfile {

    /**
     *
     * @param {Object} options
     * @param {String} options.profileId
     * @param {String} options.profileName
     * @param {Object} [options.attributes={}]
     * @param {Object} [options.metadata={}]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'UserProfile(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get profileId() {
                return `${this.ctor} options.profileId should be a String with length`;
            },
            get profileName() {
                return `${this.ctor} options.profileName should be a String with length`;
            },
            get attributes() {
                return `${this.ctor} options.attributes should be an Object`;
            },
            get metadata() {
                return `${this.ctor} options.metadata should be an Object`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { profileId, profileName, attributes = {}, metadata = {} } = options;

        nonEmptyString(profileId, errorMessage.profileId, InvalidArgumentException);
        nonEmptyString(profileName, errorMessage.profileName, InvalidArgumentException);

        if (Check.assigned(attributes)) {
            object(attributes, errorMessage.attributes, InvalidArgumentException);
        }

        if (Check.assigned(metadata)) {
            object(metadata, errorMessage.metadata, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.profileId = profileId;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.profileName = profileName;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.attributes = attributes;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.metadata = metadata;

    }

}



// WEBPACK FOOTER //
// ./src/services/account/userProfile.js